

  import firebase from "firebase";
  const firebaseApp=firebase.initializeApp({
    apiKey: "AIzaSyD_9EgxoEykrRAfX_p6rxhDDhS6w66GPi0",
    authDomain: "todolist01react.firebaseapp.com",
    projectId: "todolist01react",
    storageBucket: "todolist01react.appspot.com",
    messagingSenderId: "929191210085",
    appId: "1:929191210085:web:addf44e2e24df0b76b6a8c",
    measurementId: "G-JGM91PVFHB"

  });

  const db=firebaseApp.firestore();

  export default db;